import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Default axios — NO credentials. Public endpoints (booking, quote, lookup, callback)
// must work cross-origin from custom domains, and `withCredentials: true` combined
// with `Access-Control-Allow-Origin: *` is forbidden by the CORS spec.
// Admin auth uses Bearer token (stored in localStorage) instead of cookies.
export const api = axios.create({
  baseURL: API,
  withCredentials: false,
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
